module.exports = __webpack_public_path__ + "static/media/dk.c0cd6347.svg";